import { ProductCategory } from '../constants/products';

export function isIneligibleFitGuideProduct(product) {
  const { options } = product?.attributes?.find((attribute) =>
    attribute.field.includes('size')
  ) || { options: [] };
  const isOSFM = options?.length === 1 && options[0]?.value === 'OSFM';
  const isBag = product.productCategoryIdList.includes(ProductCategory.bags);
  const isHairAccessory = product.productCategoryIdList.includes(
    ProductCategory.hairAccessories
  );
  const isMask = product.productCategoryIdList.includes(
    ProductCategory.faceMasks
  );
  const isIneligibleFitGuideProducts =
    isBag || isHairAccessory || isMask || isOSFM;
  return isIneligibleFitGuideProducts;
}
